import { MOLONI_API_KEY } from '../config/moloni';

const MOLONI_API_URL = 'https://api.moloni.pt/v1';

export const createMoloniInvoice = async (customerData, planData) => {
  try {
    console.log('Iniciando criação de fatura na Moloni:', { customerData, planData });

    // Primeiro, criar ou buscar o cliente
    const customer = await createOrGetCustomer(customerData);
    console.log('Cliente criado/recuperado:', customer);

    // Criar a fatura
    const invoice = await createInvoice(customer.id, planData);
    console.log('Fatura criada:', invoice);

    return invoice;
  } catch (error) {
    console.error('Erro ao criar fatura na Moloni:', error);
    throw error;
  }
};

const createOrGetCustomer = async (customerData) => {
  const response = await fetch(`${MOLONI_API_URL}/customers`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${MOLONI_API_KEY}`
    },
    body: JSON.stringify({
      name: customerData.name,
      email: customerData.email,
      tax_number: customerData.taxNumber,
      address: customerData.address,
      city: customerData.city,
      postal_code: customerData.postalCode,
      country: customerData.country
    })
  });

  if (!response.ok) {
    throw new Error(`Erro ao criar cliente: ${response.statusText}`);
  }

  return await response.json();
};

const createInvoice = async (customerId, planData) => {
  const response = await fetch(`${MOLONI_API_URL}/invoices`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${MOLONI_API_KEY}`
    },
    body: JSON.stringify({
      customer_id: customerId,
      date: new Date().toISOString().split('T')[0],
      due_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      items: [{
        product_id: planData.productId,
        quantity: 1,
        price: planData.price,
        description: planData.description
      }]
    })
  });

  if (!response.ok) {
    throw new Error(`Erro ao criar fatura: ${response.statusText}`);
  }

  return await response.json();
}; 